import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import FooterButtonsRow from '../shared/FooterButtonsRow/FooterButtonsRow';

export const CancelSaleModal = ({ isOpen, toggle, cancelAction }) => {
    return (
        <div>
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                centered
                className='md'
                aria-modal='true'
                role='dialog'
                aria-labelledBy='cancel'
            >
                <ModalBody>
                    <h1
                        className='h4 py-5 mb-0'
                        id='cancel'
                    >
                        Are you sure you want to cancel your purchase?
                    </h1>
                </ModalBody>
                <ModalFooter>
                    <FooterButtonsRow
                        isModal
                        buttons={{
                            primary: {
                                text: 'Cancel Sale',
                                type: 'primary',
                                onClick: cancelAction,
                                ariaLabel: 'On click cancels sale.'
                            },
                            secondary: {
                                text: 'Resume Sale',
                                type: 'secondary',
                                onClick: toggle,
                                ariaLabel: 'On click resumes the sale.'
                            }
                        }}
                    />
                </ModalFooter>
            </Modal>
        </div>
    );
};
